
import { Component, Vue } from "vue-property-decorator";
import NiceButton from "../UI/NiceButton.vue";
import Icon from "../UI/Icon.vue";

@Component({
  components: {
    Icon,
    NiceButton
  }
})
export default class AIPluginNotInstalled extends Vue {
  goToPluginPage() {
    window.open("https://breakdance.com/ai", "_blank");
  }
}
